import { Component, OnInit } from '@angular/core';
import { ViewService } from '@services/view.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FriendService } from '@services/friend.service';
import * as _ from 'lodash';
import { CommonPipe } from '@pipes/common.pipe';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
@Component({
  selector: 'app-vmember',
  templateUrl: './vmember.component.html',
  styleUrls: ['./vmember.component.sass'],
  animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class VmemberComponent implements OnInit {
  response: any = [];
  res: any = [];
  member: any = [];
  completion = 0;
  component = "b";
  application = "member";
  pageLoading = true;
  name = "";
  cover = "";
  p_area = '';
  p_no = '';
  params: any = [];
  id = "";
  btn_process = false;
  friend: any = [];
  friend_load = false;
  media_list: any = { 'photo': 'photos', 'audio': 'audios', 'video': 'videos', 'blog': 'blogs', 'album': 'albums', 'channel': 'channels', 'playList': 'playLists', 'business': 'businesss', 'event': 'events' };
  my_list: any = { 'education': 'education', 'sports': 'sports', 'work': 'work' };
  constructor(private _friend: FriendService, private _commonPipe: CommonPipe, private router: Router, private route: ActivatedRoute, private _viewService: ViewService, private _global: GlobalService) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    this.route.queryParams.subscribe(params => {
      this.params = params;
      this.id = this.params['id'];
      let p = {
        'component': this.component,
        'application': this.application,
        'id': this.id
      };
      this._viewService.application(p).subscribe(
        data => {
          this.pageLoading = false;
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.response = this._global.getVal(data, 'response', '');
            this.completion = this._global.getProfileCompletion(this.response);
            this.name = this._global.getVal(this.response, 'firstName', '') + "  " + this._global.getVal(this.response, 'lastName', '');
            this.cover = this._commonPipe.transform(this.response, ['image', 'cover', 'id', 'name', 'l']);
            this.p_area = this._global.getVal(this.response, 'phone.phone.area', '');
            this.p_no = this._global.getVal(this.response, 'phone.phone.number', '');
            this.res = {
              firstName: this._global.getVal(this.response, 'firstName', ''),
              lastName: this._global.getVal(this.response, 'lastName', ''),
              id: this._global.getVal(this.response, 'id', ''),
              bio: this._global.getVal(this.response, 'bio', {})
            };
            this.member = {
              firstName: this._global.getVal(this.response, 'firstName', ''),
              lastName: this._global.getVal(this.response, 'lastName', ''),
              id: this._global.getVal(this.response, 'id', ''),
              countryCode: this._global.getVal(this.response, 'countryCode', ''),
              phone: this._global.getVal(this.response, 'phone', '')
            }
            this.friendCheck();

          }

        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    });
  }

  ngOnInit() {
  }
  friendCheck() {

    let p = {
      component: 'm',
      application: 'member',
      friendId: this.id
    };
    this._friend.friendCheck(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.friend_load = true;
          this.friend = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  action(action) {
    this.btn_process = true;
    let p = {
      application: 'member',
      component: this.component,
      friendId: this.id
    };
    this._friend.action(p, action).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.btn_process = false;
          this._global.showMessage({ "type": 'success', "message": this._global.getVal(data, 'message.info', '') });
          this.friendCheck();
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }

  gotoMedia(a) {
    this.router.navigate(['/' + a], { queryParams: { 'createdBy': this.id } });
  }

}
